export const GET_ALL_COMPANIES_QUERY_KEY = 'companies'
export const GET_COMPANY_STATISTICS_QUERY_KEY = 'companyStatistics'
